import {
  FacultyCard,
  LoadingListCard,
  PaginationList,
} from "Explore/Components";
import styles from "./ConceptAcademicInformation.module.scss";
import useExploreInfo from "Hooks/useExploreInfo";
import { useEffect, useRef, useState } from "react";
import { Empty } from "antd";
import { getUnitFacultyById } from "Explore/Services/Unit";
import _ from "lodash";
import { Grid } from "@mui/material";
import useFilterAndPagination from "Hooks/useFilterAndPagination";
import { ParamsFilterKey } from "Config/filterSearchParams";
import { getConceptTopScholarsByID } from "Explore/Services/Concept";

const grid = {
  gutter: [16, 16],
  xs: 1,
  sm: 1,
  md: 1,
  lg: 1,
  xl: 1,
  xxl: 1,
};

const ConceptAuthorList = () => {
  const { entity_id: conceptId } = useExploreInfo();
  const { filter } = useFilterAndPagination();
  const [data, setData] = useState({ data: [], isLoading: false });
  const [pagination, setPagination] = useState({
    page: 1,
    rowsPerPage: 12,
    totalRows: 0,
  });
  const prevFilter = useRef({});

  useEffect(() => {
    const _prevFilter = prevFilter.current;
    if (
      !_.isEqual(_prevFilter, {
        conceptId,
        [ParamsFilterKey.KEYWORD_QUERY]: filter[ParamsFilterKey.KEYWORD_QUERY],
        page: pagination.page,
        rowsPerPage: pagination.rowsPerPage,
      })
    ) {
      let newPagination = { ...pagination };
      if (
        _prevFilter.conceptId !== conceptId ||
        _prevFilter[ParamsFilterKey.KEYWORD_QUERY] !==
          filter[ParamsFilterKey.KEYWORD_QUERY] ||
        _prevFilter.rowsPerPage !== pagination.rowsPerPage
      ) {
        newPagination.page = 1;
      }

      setData({ data: [], isLoading: true });
      getConceptTopScholarsByID({
        id: conceptId,
        keyword: filter[ParamsFilterKey.KEYWORD_QUERY],
        page: newPagination.page - 1,
        rowsPerPage: newPagination.rowsPerPage,
      })
        .then((res) => {
          setData({ data: res.results, isLoading: false });
          setPagination({ ...newPagination, totalRows: res.total_count });
        })
        .catch(() => {
          setData({ data: [], isLoading: false });
          setPagination({ ...newPagination, totalRows: 0 });
        })
        .finally(() => {
          prevFilter.current = {
            conceptId,
            [ParamsFilterKey.KEYWORD_QUERY]:
              filter[ParamsFilterKey.KEYWORD_QUERY],
            page: newPagination.page,
            rowsPerPage: newPagination.rowsPerPage,
          };
        });
    } else {
      prevFilter.current = {
        conceptId,
        [ParamsFilterKey.KEYWORD_QUERY]: filter[ParamsFilterKey.KEYWORD_QUERY],
        page: pagination.page,
        rowsPerPage: pagination.rowsPerPage,
      };
    }
  }, [
    pagination.page,
    pagination.rowsPerPage,
    conceptId,
    filter[ParamsFilterKey.KEYWORD_QUERY],
  ]);

  return (
    <div className={styles["list__wrapper"]}>
      <LoadingListCard
        isLoading={data.isLoading}
        grid={grid}
        componentNum={9}
        component={
          data.data.length === 0 ? (
            <Empty description="No Author Found" />
          ) : (
            <Grid container spacing="25px">
              {data.data.map((e, i) => (
                <Grid item xs={12} key={i}>
                  <FacultyCard
                    data={{
                      ...e,
                      ...e.specific_stats,
                    }}
                  />
                </Grid>
              ))}
            </Grid>
          )
        }
      />
      <PaginationList
        pagination={pagination}
        setPagination={setPagination}
        pageSizeOptions={[12, 36, 48, 60]}
      />
    </div>
  );
};

export default ConceptAuthorList;
